import React from "react";
import { Helmet } from "react-helmet";

function PageHelmet(props) {
    const { title, description, children } = props;
    const defaultTitle = "Gopi Kachhadiya | Top Rated React Native & Expo Developer";

    return (
        <Helmet>
             <title>{title ? title : defaultTitle}</title>
            {description && <meta name="description" content={description} />}
            {children}
        </Helmet>
    );
}

export default PageHelmet;
